export function ViewIcon({ className }: { className?: string }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g opacity="0.6">
        <path d="M13.5 10.5L18.75 5.25M18.75 5.25H14.25M18.75 5.25V9.75M10.5 13.5L5.25 18.75M5.25 18.75H9.75M5.25 18.75L5.25 14.25" stroke="black" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </g>
    </svg>
  );
}

export const displayName = "ViewIcon";
